import { memo } from 'react';
import { Img } from '@chakra-ui/react';
import ShizaiLogoImage from 'public/images/shizai_logo.svg';

const ShizaiLogo = memo(() => <Img src={ShizaiLogoImage} w="8rem" h="2.5rem" alt="shizaiのロゴ" />);

ShizaiLogo.displayName = 'ShizaiLogo';

export default ShizaiLogo;
